import script from "./bank-transfer-report.vue?vue&type=script&setup=true&lang=js"
export * from "./bank-transfer-report.vue?vue&type=script&setup=true&lang=js"

import "./bank-transfer-report.vue?vue&type=style&index=0&id=04201588&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04201588"]])

export default __exports__